import type { TransferHeader as XpaTransferHeader } from "@motain/xpa-proto-files-web/lib/types/transfer_header";
import type { FC } from "react";
import { isNonNullable } from "@/types/isNonNullable";
import { TransferPlayerHeader } from "@/xpa-components/transfer-player-header/TransferPlayerHeader";
import { TransferKindCard } from "@/xpa-components/transfer-kind-card/TransferKindCard";
import { HorizontalSeparator } from "@/xpa-components/horizontal-separator/HorizontalSeparator";
import styles from "./TransferHeader.module.scss";
import classNames from "classnames";

export const TransferHeader: FC<XpaTransferHeader> = (props) => {
  const { transferPlayerHeader, transferKindCard, title } = props;
  return (
    <div className={styles.container}>
      <p className={classNames("title-7-bold", styles.title)}>{title}</p>

      <div className={styles.content}>
        {isNonNullable(transferPlayerHeader) && (
          <TransferPlayerHeader
            {...transferPlayerHeader}
          ></TransferPlayerHeader>
        )}
        <HorizontalSeparator className={styles.separator}></HorizontalSeparator>

        {isNonNullable(transferKindCard) && (
          <TransferKindCard {...transferKindCard}></TransferKindCard>
        )}
      </div>
    </div>
  );
};
